import {
  createRouteOnlyAnalysisUrlInfoHandler,
  flattenUrlCollectionRoutes,
  getEmptyUrlCollectionEntityDetailsResult,
  getUrlCollectionEntityDetailsResult,
  isUrlCollectionRouteMatched,
} from '@home/utils/urlCollectionCommon';
import {
  EntityType,
  IGetEntityDetailsByIdResult,
  IAnalysisUrlInfoParams,
  IAnalysisUrlInfoResult,
  Permission,
} from '@/pages/home/enums/urlCollection';
import { DBSystemCode } from '@home/_config/config';
import marketingRouters from './routers';

const FLATTENED_ROUTES = flattenUrlCollectionRoutes(marketingRouters);

export function isMarketingRouteMatched(pathname: string): boolean {
  return isUrlCollectionRouteMatched(pathname, FLATTENED_ROUTES);
}

export interface IEntityDetails {
  entity_type: EntityType[];
  entity_id: string;
  entity_name: string;
  entity_cover: string;
  permission: Permission;
}

export interface IEntityDetailsParams {
  entity_type?: EntityType;
  entity_id?: string;
  entity_name?: string;
  entity_cover?: string;
  [key: string]: any;
}

/**
 * 营销模块无实体概念，直接返回参数中的实体信息
 */
export async function getEntityDetailsById(
  params: IEntityDetailsParams,
): Promise<IGetEntityDetailsByIdResult> {
  if (!params.entity_id) {
    return getEmptyUrlCollectionEntityDetailsResult();
  }

  return {
    ...getUrlCollectionEntityDetailsResult({
      entityType: params.entity_type || '',
      entityId: params.entity_id,
      entityName: params.entity_name || '',
      entityCover: params.entity_cover || '',
    }),
  };
}

/**
 * 营销 URL 收藏解析
 * 营销模块无实体，只校验 URL 是否属于营销模块，直接返回可用状态
 */
export async function analysisUrlInfo(
  params: IAnalysisUrlInfoParams,
): Promise<IAnalysisUrlInfoResult> {
  return createRouteOnlyAnalysisUrlInfoHandler({
    systemCode: DBSystemCode.Marketing,
    isRouteMatched: isMarketingRouteMatched,
  })(params);
}
